export const en = {
    'unhandled-error': 'An unexpected error occurred during the query'
};
